export const Regions: { [region: string]: boolean } = {
  US: true,
  CA: true,
  AU: true,
}
